import React, { Component } from "react";

import LoginService from "@Services/Login";
import { isNull, atou } from "@Utils/helpers.js";
import { authenticate } from "@Actions/authActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

class MultiLogin extends Component {
  state = {
    nextHopp: "",
    token: "",
    id: "",
    errorMessage: null,
  };

  dString =
    this.props.location.search && this.props.location.search.split("?d=").length > 1
      ? this.props.location.search.split("?d=")[1]
      : null;
  data = this.dString ? JSON.parse(Buffer.from(this.dString, "base64")) : null;

  componentDidMount() {
    const { location } = this.props;
    // should only be ?d= so we check for it
    if (!location.search || !location.search.startsWith("?d=")) {
      this.setState({ errorMessage: "Invalid redirect URL" });
      return;
    }

    if (this.data && this.data.nextHopp && this.data.command === "logoff") {
      localStorage.clear();
      window.location.href = this.data.nextHopp;
      return;
    }

    if (!this.data || (!this.data.id && !this.data.token && !this.data.nextHopp)) {
      this.setState({ errorMessage: "Invalid data provided" });
      return;
    }

    if (this.data.id && this.data.token) {
      // authenticate
      LoginService.authenticateSSO(this.data.id, this.data.token)
        .then((response) => {
          // Handle successful authentication
          if (response && response.token) {
            localStorage.setItem("Token", response.token);
            var userData = JSON.parse(atou(response.token.split(".")[1]));
            localStorage.setItem("LoginName", userData.username);
            localStorage.setItem("ownParty", userData.ownParty);
            localStorage.setItem("Token", response.token);
            localStorage.setItem("Id", userData.userid);
            localStorage.setItem("UserName", userData.username);
            localStorage.setItem("Name", userData.Name);
            localStorage.setItem("FirstName", userData.userFirstName);
            localStorage.setItem("LastName", userData.userLastName);
            localStorage.setItem("Email", userData.email);
            localStorage.setItem("CultureID", userData.cultureId);
            localStorage.setItem("CustomerID", userData.customerID);
            localStorage.setItem("AvatarID", userData.avatarID);
            localStorage.setItem("AvatarImage", "");
            localStorage.setItem("IAT", userData.iat);
            localStorage.setItem("CD", userData.cd);
            localStorage.setItem("HasBothPortals", userData.hasBothPortals);
            localStorage.setItem("RoleID", userData.userRoleID);
            localStorage.setItem(
              "media_info_config",
              JSON.stringify(userData.media_info_config),
            );
            if (isNull(localStorage.getItem("SelectedFilters"))) {
              localStorage.setItem(
                "SelectedFilters",
                JSON.stringify({ domain: 0, case: 0, media: 0 }),
              );
            }
            this.props.actionAuthenticate();
            window.location.href = this.data.nextHopp || "/";
          }
        })
        .catch((error) => {
          // Handle authentication error
          if (error.response && error.response.data === "Login outdated.") {
            this.setState({
              errorMessage: "Login session expired... redirect to login again",
            });
          } else {
            this.setState({
              errorMessage: "Login failed...",
            });
          }
          setTimeout(() => {
            if (this.data.nextHopp) window.location.href = this.data.nextHopp;
            else window.location.href = "https://account.pixray.com/login";
          }, 1000);
        });
    } else if (this.data.nextHopp) {
      window.location.href = this.data.nextHopp;
    }
  }

  render() {
    return (
      <div>
        {this.state && this.state.errorMessage ? (
          <p>{this.state.errorMessage}</p>
        ) : (
          <h1>
            Logging you{" "}
            {this.data && this.data.nextHopp && this.data.command === "logoff"
              ? "out"
              : "in"}
            ...
          </h1>
        )}
      </div>
    );
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionAuthenticate: authenticate,
    },
    dispatch,
  );
}

export default connect(null, matchDispatchToProps)(MultiLogin);
